<kendo-dialog
        *ngIf="opened"
        [title]="title">
    <div class="EnvironmentDialogOutside">
        <div>
            <label>Enter Password</label>
            <input [(ngModel)]="_password" class="formulaBox"  kendoTextBox/>
        </div>
    </div>
    <kendo-dialog-actions>
        <button (click)="close($event)" kendoButton>Cancel</button>
        <button (click)="close($event)" kendoButton primary="true">Ok</button>
    </kendo-dialog-actions>
</kendo-dialog>


